import { collection, getDocs, getDoc, doc, setDoc, addDoc, serverTimestamp, query, where } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

export const DEFAULT_COMMUNITIES = [
    { id: 'ttc_warriors', name: 'TTC Warriors' },
    { id: 'pregnant_proud', name: 'Pregnant & Proud' },
    { id: 'pcos_circle', name: 'PCOS Support Circle' },
    { id: 'perimenopause_pioneers', name: 'Perimenopause Pioneers' },
    { id: 'cycle_syncing', name: 'Cycle Syncing Squad' },
    { id: 'pals_support', name: 'PALS Safe Space' },
    { id: 'first_timers', name: 'First-Time Moms' },
    { id: 'self_care', name: 'Self-Care Sanctuary' },
];

async function seedWelcomeMessage(db, roomId, communityName, roomLabel) {
    const uid = getAuth().currentUser?.uid;
    if (!uid) return;

    const roomRef = doc(db, 'chat_rooms', roomId);
    const roomSnap = await getDoc(roomRef);
    if (!roomSnap.exists()) return;

    const messages = await getDocs(collection(db, 'chat_rooms', roomId, 'messages'));
    if (!messages.empty) return;

    const content = `Welcome to ${communityName} — ${roomLabel}. This is a supportive space. Be kind, and ask anything.`;
    await addDoc(collection(db, 'chat_rooms', roomId, 'messages'), {
        senderId: uid,
        senderName: 'Ovuloom',
        content,
        createdAt: serverTimestamp(),
        isAnonymous: false,
        type: 'text',
        senderRole: 'moderator',
    });
    await setDoc(roomRef, {
        lastMessageAt: serverTimestamp(),
        lastMessagePreview: content.slice(0, 80),
        lastMessageSender: 'Ovuloom',
        messageCount: 1,
    }, { merge: true });
}

export async function seedDefaultChatRooms(db) {
    for (const community of DEFAULT_COMMUNITIES) {
        const existing = await getDocs(
            query(collection(db, 'chat_rooms'), where('communityId', '==', community.id))
        );
        if (!existing.empty) continue;

        const isPals = community.id === 'pals_support';
        await Promise.all([
            setDoc(doc(db, 'chat_rooms', `${community.id}_general`), {
                communityId: community.id,
                name: 'General Chat',
                description: `General discussion for ${community.name}`,
                emoji: '💬',
                topic: community.name,
                memberCount: 0,
                messageCount: 0,
                isLocked: false,
                isPalsRoom: isPals,
                createdAt: serverTimestamp(),
                lastMessageAt: serverTimestamp(),
            }),
            setDoc(doc(db, 'chat_rooms', `${community.id}_support`), {
                communityId: community.id,
                name: 'Support Circle',
                description: 'A safe space to share and receive support',
                emoji: '🤗',
                topic: community.name,
                memberCount: 0,
                messageCount: 0,
                isLocked: false,
                isPalsRoom: isPals,
                createdAt: serverTimestamp(),
                lastMessageAt: serverTimestamp(),
            }),
        ]);
    }

    await Promise.all(DEFAULT_COMMUNITIES.flatMap((community) => [
        seedWelcomeMessage(db, `${community.id}_general`, community.name, 'General Chat'),
        seedWelcomeMessage(db, `${community.id}_support`, community.name, 'Support Circle'),
    ]));

    return getDocs(collection(db, 'chat_rooms'));
}
